import { render } from "./lifeIndex.vue?vue&type=template&id=590a83ce&scoped=true"
import script from "./lifeIndex.vue?vue&type=script&lang=js"
export * from "./lifeIndex.vue?vue&type=script&lang=js"

import "./lifeIndex.vue?vue&type=style&index=0&id=590a83ce&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590a83ce"]])

export default __exports__